export default "__VITE_ASSET__DSSZyx_x__"